module.exports = __webpack_public_path__ + "img/2021042209195652915g.c5b6ab30.png";